import { SchoolAddress } from '../instructor-sample.interface';

export function getInstructorSampleSchoolAddressLabel(isVirtual: boolean): string {
  return isVirtual ? 'School Address' : 'Delivery Address';
}

export function getInstructorSampleSchoolAddressDescription(isVirtual: boolean): string {
  return isVirtual ? 'Select School Address' : 'Select School Delivery Address';
}

export function hasInstructorSampleSfdcAddressId(schoolAddress: SchoolAddress): boolean {
  return !!schoolAddress.sfdcAddressId?.trim();
}

export function getValidInstructorSampleInstitutions(schoolAddressList: SchoolAddress[]): SchoolAddress[] {
  return schoolAddressList.filter(
    (schoolAddress) =>
      schoolAddress.deptId == null &&
      schoolAddress.schoolId != null &&
      hasInstructorSampleSfdcAddressId(schoolAddress)
  );
}

export function getInstructorSampleSchoolAddressesForSchool(
  schoolAddressList: SchoolAddress[],
  schoolId: string
): SchoolAddress[] {
  return schoolAddressList.filter(
    (schoolAddress) =>
      schoolAddress.schoolId === schoolId &&
      hasInstructorSampleSfdcAddressId(schoolAddress)
  );
}
